import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
  gap: 15px;

  ${breakpoint("tablet")`
    gap: 5px;
    flex-direction: row; /* Default: Horizontal layout */
    align-items: center;
  `}
`

export const Button = styled.button`
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 8px;
  border: none;
  cursor: pointer;
  width: 100%;
  padding: 10px 0;

  background-color: ${({ num }) => {
    if (num <= 6) return "#ffd9d8" // Red-300
    if (num <= 8) return "#ffe8d1" // Yellow-200
    return "#d1f0d4" // Green-200
  }};

  ${breakpoint("tablet")`
    max-width: 50px; /* Prevents huge buttons on large screens */
    font-size: clamp(0.8rem, 2vw, 1rem); /* Responsive text size */
    aspect-ratio: 1 / 1;
    padding: 0;
    &:hover {
      filter: brightness(0.9);
    }

    width: ${({ length }) => `calc(100% / ${length})`}; /* Makes all buttons equal width */
  `}

  ${({ selected }) =>
    selected &&
    css`
      outline: 1px solid #000;
    `}
`
export const Helpers = styled.div`
  display: none;

  ${breakpoint("tablet")`
    display: flex;
    justify-content: space-between;
  `}
`
